import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { ServiceListForAccount } from '../models';
import { PaymentMethodGroup, RequestType } from '../types';
import { ServiceGroupType } from './service-group-type';
import { ServicePublicList } from './service-public-list';


@Injectable({
	providedIn: 'root'
})
export class TcServiceService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) { }

	getFilterAll(requestType: RequestType, paymentMethodGroup: PaymentMethodGroup): Observable<ServicePublicList[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/payment-methods/e-money?requestType=${requestType}`;
		return this.httpClient
			.get<ServicePublicList[]>(url)
			.pipe(map(
				res => {
					return res['data'];
				}));
	}

	getForAccount(serviceGroupType: ServiceGroupType): Observable<ServiceListForAccount[]> {
		return this.httpClient
			.get<ServiceListForAccount[]>(`${this.appConfig.apiEndpoint}/new-core/e-money/providers`)
			.pipe(map(this.utilsService.handleResponse));
	}

	// use for getting subServices in select payment methods
	getSubServices(requestType: RequestType, serviceId: number): Observable<ServicePublicList[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/e-money/providers/${serviceId}/sub-providers?requestType=${requestType}`;

		return this.httpClient
			.get<ServicePublicList[]>(url)
			.pipe(map(this.utilsService.handleResponse));
	}
}
